{
  "page": {
    "title": "Finance",
    "subtitle": "Balance, loans, and transaction history",
    "seasonReport": "Season report",
    "loadingAria": "Loading finances"
  },
  "tabs": {
    "overview": "Overview",
    "loans": "Loans",
    "history": "History",
    "sponsors": "Sponsor"
  },
  "loanSummary": {
    "active": "{count, plural, one {1 active loan} other {# active loans}}",
    "owed": "{value} CZ$ remaining",
    "none": "No active loans",
    "view": "Manage loans"
  },
  "history": {
    "interestSplit": "Interest {interest} CZ$ · Principal {principal} CZ$",
    "seasonPicker": "Season",
    "allSeasons": "All seasons",
    "option": "Season {number}",
    "optionActive": "Season {number} (ongoing)",
    "categoryFilterAria": "Filter transactions by category",
    "category": {
      "all": "All",
      "salary": "Salaries",
      "prizes": "Prizes",
      "loans": "Loans",
      "transfers": "Transfers & auctions",
      "sponsor": "Sponsor",
      "other": "Other"
    },
    "loadMore": "Show more",
    "loadingMore": "Loading...",
    "txLoadError": "Could not load transactions. Please try again."
  },
  "loadError": {
    "message": "Could not load your finances. Please try again.",
    "retry": "Try again"
  },
  "balance": {
    "label": "Balance",
    "division": "Division {division}",
    "available": "{value} CZ$ available",
    "lockedInBids": "{value} CZ$ locked in bids"
  },
  "debt": {
    "label": "Total debt",
    "ceiling": "Cap: {value} CZ$",
    "headroom": "Room under cap: {value} CZ$",
    "accruedInterest": "Incl. {value} CZ$ interest accrued"
  },
  "prize": {
    "label": "Prize money (season {season})",
    "labelNoSeason": "Prize money",
    "raceCount": "{count, plural, one {1 race} other {# races}}",
    "allSeasons": "all seasons: {amount} CZ$"
  },
  "prizeList": {
    "title": "Race prizes",
    "fallbackName": "Prize money",
    "viewRace": "View race",
    "header": {
      "race": "Race",
      "date": "Date",
      "amount": "Prize"
    }
  },
  "loans": {
    "types": {
      "short": "Short-term loan",
      "long": "Long-term loan",
      "emergency": "Emergency loan"
    },
    "active": {
      "title": "Active loans",
      "empty": "No active loans",
      "createdAt": "Taken {when}",
      "remaining": "remaining",
      "principal": "Principal",
      "interestPerSeason": "Interest/season",
      "seasonsRemaining": "Seasons left",
      "accruedInterest": "Interest accrued",
      "startRepay": "Pay installment",
      "startRepayBlocked": "Nothing to repay right now: your available balance is tied up in active bids.",
      "startRepayMaxPlaceholder": "Max {value}",
      "repayPlaceholder": "0",
      "repayBtn": "Pay",
      "repayingBtn": "...",
      "cancelRepayAria": "Cancel"
    },
    "take": {
      "title": "Take out a loan",
      "noConfig": "No loan configuration available for Division {division}",
      "typeLabel": "Loan type",
      "amountLabel": "Amount (CZ$)",
      "amountPlaceholder": "e.g. 500",
      "feeLabel": "Fee ({pct}%)",
      "feeValue": "{value} CZ$",
      "interestLabel": "Interest/season",
      "interestValue": "{pct}%",
      "totalLabel": "Total repayment",
      "totalValue": "{value} CZ$",
      "maxBorrowable": "Max loan right now: {value} CZ$",
      "maxBorrowableDetail": "The fee of {fee} CZ$ is added to your debt, so it reaches {total} CZ$ of the {ceiling} CZ$ cap.",
      "useMax": "Use max",
      "maxZero": "No room for a new loan. Your debt is at the division cap of {ceiling} CZ$.",
      "exceedsMax": "This would push you over the debt cap, because the fee counts towards it. Max loan right now: {value} CZ$.",
      "submit": "Take loan",
      "processing": "Processing..."
    },
    "confirmModal": {
      "title": "Confirm large loan",
      "body": "You're about to borrow <strong>{principal} CZ$</strong> plus a <strong>{fee} CZ$</strong> fee. Your total debt becomes <strong>{newTotalDebt} CZ$</strong>, {pct}% of your division's {ceiling} CZ$ debt cap.",
      "question": "Take out this loan anyway?",
      "confirm": "Take loan"
    },
    "terms": {
      "title": "Loan terms, Division {division}",
      "headers": {
        "type": "Type",
        "fee": "Fee",
        "interest": "Interest/season",
        "seasons": "Seasons",
        "debtCeiling": "Debt cap"
      }
    }
  },
  "transactions": {
    "history": {
      "title": "Transaction history",
      "empty": "No transactions yet"
    },
    "type": {
      "sponsor": "Sponsor income",
      "salary": "Salaries",
      "transfer_out": "Transfer (bought)",
      "transfer_in": "Transfer (sold)",
      "loan_received": "Loan received",
      "loan_repayment": "Loan installment",
      "loan_interest": "Loan interest",
      "emergency_loan": "Emergency loan",
      "prize": "Prize money",
      "bonus": "Division bonus",
      "admin_adjustment": "Admin adjustment",
      "interest": "Interest",
      "academy_signing": "Academy signing",
      "academy_drift": "Academy upkeep",
      "facility_upkeep": "Facility upkeep",
      "staff_salary": "Staff salaries",
      "parachute": "Relegation parachute",
      "sponsor_race_day": "Sponsor income per stage",
      "sponsor_signing_bonus": "Sponsor signing bonus",
      "sponsor_objective_bonus": "Sponsor objective bonus",
      "sponsor_result_bonus": "Sponsor result bonus",
      "facility_purchase": "Facility upgrade",
      "staff_severance": "Staff severance",
      "upkeep": "Upkeep",
      "travel_staff": "Travel & staff",
      "scout_travel": "Scout travel",
      "auto_squad_purchase": "Automatic squad purchase",
      "auto_squad_sale": "Automatic squad sale",
      "forced_debt_sale": "Forced sale (debt ceiling)",
      "squad_violation_fine": "Squad-size fine",
      "starting_budget": "Starting budget",
      "division_adjustment": "Division adjustment",
      "sponsor_division_correction_clawback": "Sponsor correction (refund)"
    }
  },
  "timeAgo": {
    "unknown": "Unknown",
    "now": "Just now",
    "minutes": "{m}m ago",
    "hours": "{h}h ago",
    "days": "{d}d ago"
  },
  "msg": {
    "loanCreated": "Loan of {amount} CZ$ created",
    "loanRepaidFull": "Loan fully repaid!",
    "loanRepaidPartial": "{paid} CZ$ paid, {remaining} CZ$ remaining",
    "errorPrefix": ""
  },
  "tour": {
    "balance": {
      "title": "Your balance and cashflow",
      "body": "Balance changes from sponsor (income at season start), salaries (paid at the start of the next season after sponsor lands), transfers, and prize money (ongoing). Red numbers mean negative balance, and the emergency-loan mechanism kicks in at the next season start if sponsor and balance cannot cover salary and interest."
    },
    "debtCeiling": {
      "title": "Debt cap per division",
      "body": "Each division has a cap on total debt (D1 1,200K · D2 900K · D3 600K · D4 400K). Once the cap is reached, new loans are blocked, and the board also penalises overspending at season evaluation."
    },
    "txHistory": {
      "title": "Follow the cashflow",
      "body": "Sponsor and salary are one-off per season (both at season start: sponsor first, then salary), while prize money and transfers come in continuously. Here you see every transaction, use it to track whether the finances are heading the right way."
    }
  },
  "hint": {
    "title": "How your finances work",
    "subtitle": "Four income and expense streams drive your balance. Understand them, and you can prioritise sport, growth, and debt.",
    "dismissAria": "Hide",
    "sponsor": {
      "title": "Sponsor income",
      "before": "Scaled by division (D1 600,000 · D2 400,000 · D3 340,000 CZ$) per season × your ",
      "linkText": "board modifier",
      "after": ". Paid as a lump sum at season start."
    },
    "salary": {
      "title": "Rider salaries",
      "body": "A rider's wage is the price of what he delivers this season, not what he is worth on the market. It is a fixed share of his current production value, the same share for every team in every division, so a better rider always costs more. Wages are frozen when you sign or extend, so a rider's wage does not move with his market value afterwards. Deducted as a lump sum at the start of the next season, right after the sponsor lands."
    },
    "debt": {
      "title": "Debt cap per division",
      "body": "D1 1,200K · D2 900K · D3 600K · D4 400K. Break the cap and new loans are blocked, and the board punishes overspending."
    },
    "loans": {
      "title": "Loans, short vs long",
      "body": "Short loan: low fee, fast repayment. Long loan: larger amount across several seasons. Use them for transfer peaks, not operating gaps."
    },
    "showTour": "Show me around",
    "skip": "Skip"
  },
  "report": {
    "season": "Season {n}",
    "livePreview": " · live preview",
    "cashflowOverview": "Cashflow overview",
    "ongoing": " – ongoing",
    "netCashflow": "Net cashflow",
    "transactionCount": "{count} transactions",
    "income": "Income",
    "expense": "Expenses",
    "nonCashLoanInterest": "Interest accrued on debt (non-cash, excluded from net)",
    "total": "Total",
    "activeLoans": "Active loans",
    "noActiveLoans": "No active loans.",
    "loanType": "Type",
    "loanRemaining": "Remaining debt",
    "loanInterest": "Interest",
    "loanSeasons": "Seasons",
    "loanNextInterest": "Next season's interest",
    "loanAccruedInterest": "Interest accrued",
    "loanShort": "Short loan",
    "loanLong": "Long loan",
    "loanEmergency": "Emergency loan",
    "mustLogin": "You must be logged in.",
    "errorStatus": "Error {status}",
    "loadError": "Could not load report",
    "back": "Back",
    "title": "Finance report · season {n}",
    "adminView": " · admin view",
    "donutIncomeTitle": "Income by source",
    "donutExpenseTitle": "Expenses by category",
    "donutIncomeEmpty": "No income recorded this season.",
    "donutExpenseEmpty": "No expenses recorded this season.",
    "topInTitle": "Top 3 income",
    "topOutTitle": "Top 3 expenses",
    "topInEmpty": "No income recorded.",
    "topOutEmpty": "No expenses recorded.",
    "sponsorTitle": "Sponsor modifier curve",
    "sponsorBody": "Available from season 2. Requires board plan history from at least one closed season.",
    "reasonCode": {
      "season_start_sponsor": "Sponsor",
      "season_start_upkeep": "Upkeep & maintenance",
      "race_day_travel_staff": "Travel & staff",
      "season_start_parachute": "Relegation parachute",
      "season_start_academy_drift": "Academy upkeep",
      "season_end_salary": "Salaries",
      "season_end_division_bonus": "Division bonus",
      "season_end_negative_interest": "Negative interest",
      "season_end_loan_interest": "Loan interest",
      "starting_budget": "Starting budget",
      "race_prize_payout": "Prize money",
      "auction_winner_payment": "Auction purchase",
      "auction_seller_payout": "Auction sale",
      "auction_guaranteed_bank_sale": "Bank-guaranteed sale",
      "intake_expiry_auction_compensation": "Intake expiry compensation",
      "transfer_purchase": "Transfer purchase",
      "transfer_sale": "Transfer sale",
      "swap_cash_delta": "Swap (cash difference)",
      "sponsor_race_day": "Sponsor (per stage)",
      "rider_release_buyout": "Release fee",
      "loan_fee_paid": "Loan fee paid",
      "loan_fee_received": "Loan fee received",
      "loan_fee_refunded": "Loan fee refunded",
      "loan_principal_received": "Loan taken out",
      "loan_repayment": "Loan repayment",
      "loan_buyout": "Loan bought out",
      "loan_origination_fee": "Loan origination fee",
      "emergency_loan_received": "Emergency loan",
      "squad_auto_purchase": "Forced rider purchase",
      "squad_auto_sale": "Forced rider sale",
      "squad_violation_fine": "Squad-composition fine",
      "board_bonus_accepted": "Board bonus",
      "admin_balance_adjustment": "Admin adjustment",
      "admin_force_prize": "Admin prize award",
      "admin_beta_reset": "Beta reset",
      "facility_purchase": "Facility purchases",
      "scout_travel": "Scout travel",
      "unknown": "Other"
    }
  }
}
